<h2 mat-dialog-title>
    <mat-icon color="primary" class="dialogIcon">settings</mat-icon
    >{{ data.screenName != null ? data.screenName : "Paramétrage de l'écran" }}
</h2>
<p class="subTitle main">Paramètres</p>

<mat-dialog-content>
    <!-- Partie Horaires -->
    <h3><mat-icon color="primary" class="dialogIcon">schedule</mat-icon>Horaires d'affichage</h3>
    <p class="subTitle">{{ isReadOnly ? 'Voir' : 'Gérer' }} les tranches horaires où l'écran est allumé</p>

    <div class="timeLoading" *ngIf="!isTimersLoaded">
        <mat-spinner [diameter]="50"></mat-spinner>
        <p><i>Chargement des horaires ...</i></p>
    </div>

    <div class="timeContent" *ngIf="isTimersLoaded">
        <table class="timeTableContent mat-elevation-z8" aria-describedby="Programmation allumage/arrêt">
            <ng-container *ngIf="isDateSimpleMode">
                <th>Jour</th>
                <th>Ouverture</th>
                <th>Fermeture</th>
                <th></th>
            </ng-container>

            <!-- MODE AVANCE -->
            <ng-container *ngIf="!isDateSimpleMode">
                <th colspan="2">Ouverture</th>
                <th colspan="2">Fermeture</th>
                <th></th>
                <tr style="margin-bottom: 10px">
                    <td>Jour d'ouverture</td>
                    <td>Heure d'ouverture</td>
                    <td>Jour de fermeture</td>
                    <td>Heure de fermeture</td>
                    <td></td>
                </tr>
            </ng-container>

            <!-- Lignes d'horaires -->
            <ng-container [formGroup]="timeForm">
                <ng-container formArrayName="timers">
                    <tr *ngFor="let timer of screenTimers; let i = index" [formGroupName]="i">
                        <!-- Sélecteur de Début jours -->
                        <td>
                            <mat-form-field appearance="outline" class="daySelector">
                                <mat-label>Jour(s)</mat-label>
                                <mat-select formControlName="startDay" multiple>
                                    <mat-option *ngFor="let days of daysOfWeek" [value]="days.value">{{
                                        days.viewValue
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <!-- Heure d'ouverture -->
                        <td>
                            <wncm-form-control-text
                                [control]="timersFormArray.controls[i].controls.start"
                                placeholder="Heure d'allumage"
                                ctype="time"
                                [showClearButton]="!isReadOnly"
                                [readOnly]="isReadOnly"
                            >
                            </wncm-form-control-text>
                        </td>

                        <!-- Sélecteur de FIN jours -->
                        <td *ngIf="!isDateSimpleMode">
                            <mat-form-field appearance="outline" class="daySelector">
                                <mat-label>Jour(s)</mat-label>
                                <mat-select [disabled]="isReadOnly" formControlName="endDay" multiple>
                                    <mat-option *ngFor="let days of daysOfWeek" [value]="days.value">{{
                                        days.viewValue
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>

                        <!-- Heure d'extinction -->
                        <td>
                            <wncm-form-control-text
                                [control]="timersFormArray.controls[i].controls.end"
                                placeholder="Heure d'extinction"
                                ctype="time"
                                [showClearButton]="!isReadOnly"
                                [readOnly]="isReadOnly"
                            >
                            </wncm-form-control-text>
                        </td>
                        <td>
                            @if (!isReadOnly) {
                                <button
                                    style="margin-bottom: 20px"
                                    matTooltip="Suppression de l'horaire"
                                    mat-icon-button
                                    (click)="removeTimer(i)"
                                >
                                    <mat-icon color="primary">delete</mat-icon>
                                </button>
                            }
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
            <!-- Si pas de données -->
            <tr *ngIf="screenTimers.length <= 0">
                <td colspan="5">
                    <p class="fullContentRow">
                        <i>Pas d'horaires enregistrées</i>
                    </p>
                </td>
            </tr>
            <!-- Ajout d'horaire(s) -->
            <tr *ngIf="screenTimers.length < 7 && !isReadOnly">
                <td colspan="5">
                    <button mat-stroked-button color="primary" (click)="addNewTimer()" class="fullContentRow">
                        <mat-icon>add</mat-icon> Ajouter des horaires ({{ screenTimers.length }}/7)
                    </button>
                </td>
            </tr>
        </table>

        <mat-slide-toggle style="margin-top: 10px; display: none" [(ngModel)]="isDateSimpleMode"
            >Mode Simple</mat-slide-toggle
        >
    </div>

    <!-- Partie modération -->
    <!-- <h3><mat-icon color="primary" class="dialogIcon">verified_user</mat-icon>Modération</h3>
    <div><i>WIP</i></div> -->

    <!-- DEBUG -->
    <!-- <button style="margin-top: 30px;" mat-stroked-button (click)="test()">test</button> -->
    <!-- <button (click)="getCurrentTimers()" mat-stroked-button>Get</button>
    <button (click)="setNewTimers()" mat-stroked-button>Set</button> -->
</mat-dialog-content>

<mat-dialog-actions style="justify-content: end">
    @if (!isReadOnly) {
        <button mat-raised-button mat-dialog-close tabindex="-1">Annuler</button>
        <button (click)="validTimers()" mat-raised-button color="primary" cdkFocusInitial>Valider</button>
    } @else {
        <button mat-dialog-close mat-raised-button color="primary" cdkFocusInitial>Fermer</button>
    }
</mat-dialog-actions>
